<template>
  <div class="manage-entries my-3">
    <b-breadcrumb class="align-items-center">
      <b-breadcrumb-item :to="{ name: 'ManageAll' }" active>Manage</b-breadcrumb-item>
    </b-breadcrumb>
    <b-card no-body>
      <b-table :busy="$apollo.queries.totals.loading" :fields="fields" :items="items">
        <template v-slot:table-busy>
          <b-spinner variant="primary" type="grow" label="Loading"/>
        </template>
        <template v-slot:cell(name)="{ value, item: { id: entryType, icon } }">
          <font-awesome-icon v-if="icon" class="text-muted" :icon="icon" style="width: 30px;"/>
          <router-link :to="{ name: 'ManageEntryList', params: { entryType } }">{{ value }}</router-link>
        </template>
        <template v-slot:cell(total)="{ item: { id: entryType } }">
          {{ totals && totals[entryType] ? totals[entryType].total : 0 }}
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import gql from 'graphql-tag';

export default {
  name: 'ManageAll',
  apollo: {
    totals: {
      query: gql`
        query ManageTotals {
          company {
            id
            jobs: jobConnections {
              total
            }
            segments: segmentsConnection {
              total
            }
            users: userConnections {
              total
            }
            # jobApplications: applicationConnections {
            #   total
            # }
          }
        }
      `,
      variables() {
        const { companyID } = this.$route.params;
        return { companyID };
      },
      update: ({ company }) => company,
      errorPolicy: 'all',
      fetchPolicy: 'no-cache',
    },
  },
  metaInfo: {
    title: 'Manage',
  },
  computed: {
    fields: () => ([
      { key: 'name' },
      { key: 'total' },
    ]),
    items: () => ([
      { id: 'jobs', name: 'Jobs', icon: 'briefcase' },
      { id: 'segments', name: 'Segments', icon: 'chart-pie' },
      { id: 'users', name: 'Users', icon: 'users' },
      // { id: 'jobApplications', name: 'Job Applications' },
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/views/manage/all.vue